import User from "@/modules/user/models/User";
import { IncomingInvoiceTimelineDescriptionItem, IncomingInvoiceTimelineItem } from "../../actionLog/models/index";
import dayjs, { Dayjs } from "dayjs";

export default class IncomingInvoiceRemark implements IncomingInvoiceTimelineItem {
  invId = 0;
  statusId = 1;
  status = "-";
  userName = "-";
  date: string | Date = new Date();
  remark = "";
  relatedUsers: User[] = [];

  constructor(params?: Partial<IncomingInvoiceRemark>) {
    const data = { ...params };
    Object.assign(this, data);
  }

  /*
   * IncomingInvoiceTimelineItem implementation for IncomingInvoiceTimeline.vue
   */
  get timestamp(): Dayjs {
    return dayjs(this.date);
  }

  get title(): string {
    return `Megjegyzés`;
  }

  get subtitle(): string {
    return this.userName;
  }

  get description(): string | IncomingInvoiceTimelineDescriptionItem[] | undefined {
    const desc: IncomingInvoiceTimelineDescriptionItem[] = [
      { label: `${this.status}:`, value: `${this.remark}` }
    ];

    if (this.relatedUsers && this.relatedUsers.length > 0) {
      desc.push({label: "Megjelölt személyek:", value: this.relatedUsers.map(u => u.name).join(', ')});
    }

    return desc;
  }

  get icon(): string {
    return `fa-comment`;
  }

  get color(): string {
    return `lighten-2 orange`;
  }
}
